import {SHOW_MODAL, HIDE_MODAL} from './modalActionsTypes';

export const hideModalAction = {
	type: HIDE_MODAL,
};
// linked to GlobalModal
export const showModalAction = (title, body, actionButtonText = 'تمام', redirectTo = null) => {
	return {
		type: SHOW_MODAL,
		payload: {
			title,
			body,
			actionButtonText,
			redirectTo,
		},
	};
};
